export function interp(xs, ys, x) {
  if (!xs?.length || x == null || x < xs[0] || x > xs[xs.length - 1]) return undefined;
  let lo = 0, hi = xs.length - 1;
  while (hi - lo > 1) {
    const m = (lo + hi) >> 1;
    if (xs[m] <= x) lo = m;
    else hi = m;
  }
  const f = xs[hi] === xs[lo] ? 0 : (x - xs[lo]) / (xs[hi] - xs[lo]);
  return ys[lo] + (ys[hi] - ys[lo]) * f;
}

export const axisEnd = (lap, axis) => lap[axis][lap[axis].length - 1];

export function axisGrid(laps, axis = "t", range = null) {
  const ls = laps.filter(Boolean);
  const [x0, x1] = range || [0, Math.max(...ls.map((l) => axisEnd(l, axis)))];
  const dens = Math.max(...ls.map((l) => l[axis].length / (axisEnd(l, axis) || 1)));
  const n = Math.round(Math.min(2000, Math.max(200, dens * (x1 - x0) * 1.5)));
  return Array.from({ length: n }, (_, i) => x0 + ((x1 - x0) * i) / (n - 1));
}

export function mergeLaps(a, b, channel, grid, axis = "t", c = null) {
  const at = (l) => (l ? (x) => interp(l[axis], l.ch[channel] || [], x) : () => undefined);
  const fa = at(a), fb = at(b), fc = at(c);
  return grid.map((x) => ({ x, a: fa(x), b: fb(x), c: fc(x) }));
}

export function deltaPoints(a, b, axis = "t", c = null) {
  const dl = (l, i) => (l && l.t[i] != null ? Number((l.t[i] - a.t[i]).toFixed(3)) : undefined);
  return a[axis].map((x, i) => ({ x, delta: dl(b, i), deltaC: dl(c, i) }));
}

export function posAt(lap, pts, v, axis = "t") {
  if (!lap || !pts?.length || v == null) return null;
  const p = interp(lap[axis], pts.map((q) => q[0]), v);
  if (p === undefined) return null;
  return [p, interp(lap[axis], pts.map((q) => q[1]), v)];
}

export function sectorMarks(lap) {
  if (!lap?.sectors?.length) return [];
  let c = 0;
  return lap.sectors.slice(0, -1).map((s, i) => {
    c += s;
    return { label: `S${i + 1}`, t: c, d: interp(lap.t, lap.d, c) };
  });
}

export function fmtLap(sec) {
  if (sec == null) return "—";
  const m = Math.floor(sec / 60);
  const s = sec - m * 60;
  return m ? `${m}:${s.toFixed(3).padStart(6, "0")}` : s.toFixed(3);
}

export function speedColor(f) {
  return `hsl(${Math.round(220 - 220 * Math.min(1, Math.max(0, f)))}, 90%, 55%)`;
}

export function fullLaps(tel) {
  return tel.laps.filter((l) => l.full).sort((x, y) => x.time - y.time);
}

export function lapNumbers(tel) {
  return Object.fromEntries(tel.laps.filter((l) => l.full).sort((x, y) => x.lap - y.lap).map((l, i) => [l.lap, i + 1]));
}
